export const FETCH_PAYROLL_SALARY_DETAILS = "FETCH_PAYROLL_SALARY_DETAILS";
